import { tbImage } from "../engine/tbImage";
import { PIXI } from "../engine/tbPIXI";
export function tbImageFromImage(name, image, xOrigin, yOrigin) {
    var base = new PIXI["BaseTexture"](image);
    var texture = new PIXI["Texture"](base);
    texture.didLoad = true;
    var img = new tbImage(texture, 1);
    img.addImage(name);
    img.specialAdd(xOrigin, yOrigin);
    return img;
}
